module.exports = __webpack_public_path__ + "static/logo-6b4bb52dd9e20b58053855418ed5e852.png";